export default __webpack_public_path__ + "static/media/illustration-error.658a2e91.svg";